(ns common.queries.muix-filter-util
  (:require [camel-snake-kebab.core :as csk]
            [cljs-bean.core :refer [->clj]]
            [clojure.string :as str]))

(defn get-filter-params
  "If [:quick-filter :field] is defined, this single field will be used for quickfilter"
  ([filter-model] (get-filter-params nil filter-model))
  ([{:keys [field->resolver field->column]
     {quick-filter-field :field
      quick-filter-operator :operator
      :or {quick-filter-operator "contains"}} :quick-filter}
    {:keys [logicOperator items quickFilterValues]}]
   (let [filters (keep (fn [{:keys [field value operator]}]
                         (when (or (if (coll? value)
                                     (seq value)
                                     (some? value))
                                   (#{"isEmpty" "isNotEmpty"} operator))
                           (let [resolver (get field->resolver field)]
                             (cond-> {:operator (csk/->kebab-case operator)
                                      :column (get field->column field field)
                                      :value value}
                               resolver (assoc :resolver resolver)))))
                       (cond-> items
                         (and (some? quick-filter-field) (seq quickFilterValues))
                         (conj {:field quick-filter-field
                                :value (str/join " " quickFilterValues)
                                :operator quick-filter-operator})))]
     (when (seq filters)
       {:link-operator (or logicOperator "and")
        :filters filters}))))

(defn get-sort-params
  "Only uses the first item of sort-model, only supports one level of sorting"
  [field->sort-field
   [{table-sorting-field :field
     table-sorting-direction :sort}]
   {default-sorting-field :field
    default-sorting-direction :sort}]
  (let [get-sort-column #(get field->sort-field % %)
        [column direction]
        (if-let [column (get-sort-column table-sorting-field)]
          [column table-sorting-direction]
          [(get-sort-column default-sorting-field) default-sorting-direction])]

    (str (case direction
           "asc" "+"
           "desc" "-")
         column)))

(defn default-get-next-page-param
  [lastPage _pages]
  (-> lastPage ->clj :data last :cursor))

(defn get-query-params
  [{:keys [field->sort-field field->resolver field->column quick-filter default-sorting]
    :or {default-sorting {:field "id" :sort "asc"}}}
   {:keys [^js pagination-model ^js sort-model ^js filter-model]}
   ^js ctx]
  (let [cursor (.-pageParam ctx)
        sort-params (get-sort-params field->sort-field (->clj sort-model) default-sorting)

        filter-params (get-filter-params {:field->resolver field->resolver
                                          :field->column field->column
                                          :quick-filter quick-filter}
                                         (->clj filter-model))]
    (cond-> {:limit (.-pageSize pagination-model)}
      (some? cursor) (assoc :starting-after cursor)
      (nil? cursor) (assoc :sort sort-params)
      filter-params (assoc :muix-data-grid filter-params))))
